<template>
<div>
    <div v-if="$store.getters.activatedClub" :key="$store.getters.activatedClub.id" class="panel">
        <div class="top-button-row row columns">
          <div class="panel-title">Filtres</div>
          <div class="large-3 columns">
            compétition
            <select name="" v-if="$store.getters.formatedClubList" v-model="chosenLeague">
              <option v-for="league in $store.getters.leagueListForActivatedClub" v-bind:value="league">{{league.name}}</option>
            </select>
          </div>
          <div class="large-3 columns">
            saison
            <select name="" v-if="chosenLeague" v-model="chosenSeason">
              <option v-for="season in chosenLeague.seasons" v-bind:value="season">{{season.name}}</option>
            </select>
          </div>
          <div class="large-3 columns">
            poule
            <select name="" v-if="chosenSeason" v-model="chosenRankingGroup">
              <option v-for="rg in chosenSeason.ranking_groups" v-bind:value="rg">{{rg.name}}</option>
            </select>
          </div>
          <div class="large-3 columns">
            status
            <select name="" v-model="selectedFilter">
              <option v-bind:value="0">Toutes les équipes</option>
              <option v-bind:value="1">Equipes brouillons</option>
              <option v-bind:value="2">Equipes avec montée de niveau à faire</option>
              <option v-bind:value="3">Equipes avec achats à faire</option>
              <option v-bind:value="4">Equipes prêtes à jouer</option>
            </select>
          </div>
        </div>
    </div>
    <div v-if="$store.getters.teamList === null" class="panel-content">
        <spinner></spinner>
    </div>
    <div v-else>
        <div class="row columns mt-1">
          <div class="large-3 columns pl-0 large-centered">
            <router-link :to="{ name: 'TeamCreate' }"><button class="full-width">Nouvelle équipe</button></router-link>
          </div>
        </div>
        <div v-if="displayedTeamList.length === 0" class="panel-content">
            Rien.
            Nada.
            Walou.
            Makache.
            Peau de zoby.
        </div>
        <div v-else class="row large-up-4">
            <div class="columns columns-block" v-for="team in displayedTeamList">
                <router-link :to="{ name: 'TeamDetail', params: { id: team.id }}" >
                <div class="billboard">
                    <div class="billboard-thumbnail">
                        <img v-if="team.icon_file_path" v-bind:src="team.icon_file_path" alt="aperçu">
                        <img v-else v-bind:src="getDefaultIcon(team)" alt="aperçu">
                    </div>
                    <div class="billboard-content">
                        <div class="row columns team-title">
                            {{team.name}}
                        </div>
                        <div class="row columns team-coach">
                            <div class="row columns"><span><i class="fa fa-user" aria-hidden="true"></i> coachés par {{team.user}}</span></div>
                            <div class="row columns"><span><i class="fa fa-tag" aria-hidden="true"></i>{{team.ref_roster}}</span></div>
                            <div class="row columns"><i class="fa fa-bolt" aria-hidden="true"></i>Team Value {{team.TV}}</div>
                        </div>
                    </div>
                </div>
                </router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'

export default {
  name: 'teamList',
  components: {
    spinner
  },
  // mixins: [leagueSelector],
  data () {
    return {
      selectedFilter: 0,
      activatedTab: 1,
      selectedLeagueValue: null,
      selectedSeasonValue: null,
      selectedRankingGroupValue: null
    }
  },
  watch: {
    activatedClub: function (newVal, oldVal) {
      this.selectedLeagueValue = null
    }
  },
  computed:
  {
    activatedClub: function () {
      return this.$store.getters.activatedClub
    },
    chosenLeague: {
      get: function () {
        if (this.$store.getters.leagueListForActivatedClub && !this.selectedLeagueValue) {
          this.chosenLeague = this.$store.getters.leagueListForActivatedClub[this.$store.getters.leagueListForActivatedClub.length - 1]
        }
        return this.selectedLeagueValue
      },
      set: function (newChosenLeague) {
        this.selectedLeagueValue = newChosenLeague
        this.chosenSeason = newChosenLeague.seasons[newChosenLeague.seasons.length - 1]
      }
    },
    chosenSeason: {
      get: function () {
        return this.selectedSeasonValue
      },
      set: function (newChosenSeason) {
        this.selectedSeasonValue = newChosenSeason
        this.chosenRankingGroup = newChosenSeason.ranking_groups[newChosenSeason.ranking_groups.length - 1]
      }
    },
    chosenRankingGroup: {
      get: function () {
        return this.selectedRankingGroupValue
      },
      set: function (newRankingGroup) {
        this.selectedRankingGroupValue = newRankingGroup
      }
    },
    displayedTeamList: function () {
      let filtered = []
      if (!this.$store.getters.activatedClub) {
        return this.$store.getters.teamList
      }
      filtered = this.$store.getters.teamListForLeagueAndRankingGroup(this.chosenSeason.id, this.chosenRankingGroup.id)
      if (this.selectedFilter === 1) {
        return filtered.filter(team => { return team.status === 0 })
      }
      if (this.selectedFilter === 2) {
        return filtered.filter(team => { return team.status === 2 })
      }
      if (this.selectedFilter === 3) {
        return filtered.filter(team => { return team.status === 3 })
      }
      if (this.selectedFilter === 4) {
        return filtered.filter(team => { return team.status === 1 })
      }
      return filtered
    }
  },
  created () {
    this.$store.dispatch('showLeaguePanel')
    this.$store.dispatch('deactivateFullSizePage')
  },
  methods: {
    getDetailUrl (item) {
      return '/team/' + item.id
    },
    getDefaultIcon (item) {
      return '/static/imgs/team-icons/' + item.ref_roster + '.png'
    }
  },
  mounted () {
    this.$store.dispatch('refreshTeamList')
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs li{
    float: left;
    margin-left : 0rem;
    padding : 0.4rem 0.8rem ;
    margin-right : 0rem;
    position: relative;
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.top-button-row {
  margin-top : 1rem;
}
.team-title {
    font-size: 1.2rem;
    font-weight: 300;
    text-align: center;
    margin-bottom: 1rem;
}

.team-coach {
    font-weight: 200;
    font-size : 0.8rem;
    text-align: left;
}

.billboard {
    background-color: rgba(255,255,255,0.9);
    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    padding: 0rem;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
    -webkit-transition: opacity 0.2s, -webkit-transform 0.2s;
	transition: opacity 0.35s, transform 0.5s;
    overflow: hidden;
}

.billboard:hover {
    -webkit-transform: scale3d(0.9,0.9,0.9);
	transform: scale3d(1.1,1.1,1);
    box-shadow: 1px 1px 3px rgba(0,0,0,0.7);
}

.billboard-thumbnail {
    padding: 0rem;
    margin: 0rem;
}

.billboard-content {
    padding: 1rem 1rem;
    overflow: inherit;
}
  .pl-0 {
    padding-left: 0;
  }
  .mt-1 {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// team-list.vue?4bf73194